import React, { FC, useEffect } from 'react'
import Head from 'next/head'

const GTM_SCRIPT = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-MD45XHL');`

interface DataLayerEvent {
  event: string
  country: string
  lang: string
  name: string
}

const updateDataLayer = (dataLayer: any[], event: DataLayerEvent) => {
  dataLayer.forEach((element, index) => {
    if (element.event === 'hc.push') {
      dataLayer.splice(index, 1)
    }
  })
  dataLayer.push(event)
}

type Props = {
  countryCode: string
  langCode: string
  name: string
}

export const Tracking: FC<Props> = ({ countryCode, langCode, name }) => {
  useEffect(() => {
    const data: DataLayerEvent = {
      event: 'hc.push',
      country: countryCode,
      lang: langCode,
      name,
    }

    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || []
      updateDataLayer(window.dataLayer, data)
    }
  }, [countryCode, langCode, name])

  return (
    <React.Fragment>
      <Head>
        <script dangerouslySetInnerHTML={{ __html: GTM_SCRIPT }} />
      </Head>
      <noscript>
        <iframe
          title="GTM"
          src="https://www.googletagmanager.com/ns.html?id=GTM-MD45XHL"
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
    </React.Fragment>
  )
}
